import React from "react";
import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import { useApp } from "@/store";

export default function Footer() {
  const { t } = useApp();
  return (
    <footer className="mt-16 border-t border-gray-200 bg-white" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-5 py-10 sm:px-8 md:flex-row md:items-center md:justify-between">
        <Link to="/" className="flex items-center gap-2 font-display text-lg font-extrabold tracking-tight">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-[#002FA7] text-white"><Globe size={17} /></span>
          RentGlobe
        </Link>
        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-medium text-gray-500">
          <Link to="/how-it-works" data-testid="footer-how" className="transition-colors hover:text-[#002FA7]">{t("nav_how")}</Link>
          <Link to="/for-businesses" data-testid="footer-business" className="transition-colors hover:text-[#002FA7]">{t("nav_business")}</Link>
          <Link to="/pricing" data-testid="footer-pricing" className="transition-colors hover:text-[#002FA7]">{t("nav_pricing")}</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="transition-colors hover:text-[#002FA7]">Privacy Policy</Link>
          <Link to="/terms" data-testid="footer-terms" className="transition-colors hover:text-[#002FA7]">Terms of Service</Link>
          <Link to="/contact" data-testid="footer-contact" className="transition-colors hover:text-[#002FA7]">{t("contact")}</Link>
        </nav>
        <div className="text-xs text-gray-400">© {new Date().getFullYear()} RentGlobe · <span data-testid="footer-region">{t("serving_au")}</span> · Privacy Act compliant</div>
      </div>
      <div className="border-t border-gray-100">
        <p className="mx-auto max-w-7xl px-5 py-4 text-xs leading-relaxed text-gray-400 sm:px-8" data-testid="footer-disclaimer">{t("footer_disclaimer")}</p>
      </div>
    </footer>
  );
}
